import React, { useEffect } from 'react';
import { Steps } from 'antd';

interface IProps {
  current: number;
}

const Step: React.FC<IProps> = (props: IProps) => {
  useEffect(() => {}, []);
  return (
    <>
      <Steps
        current={props.current}
        size="small"
        responsive={false}
        items={[
          {
            title: <>เลือกที่อยู่</>,
          },
          {
            title: <>เลือกช่าง</>,
          },
          {
            title: <>ติดต่อช่าง</>,
          },
        ]}
      />
    </>
  );
};

export default Step;
